module.exports = __webpack_public_path__ + "static/media/sliderRightArrow.f9353983.svg";